<template>
  <div class="pravila">
    <!-- navbar -->
    <Navbar showBackButton></navbar>
    <div class="container">

        <PanelPokreni v-if="appState == 'round-in-progress'"/>

        <div class="cnt" v-html="html" :class="{'m-top': poweredBy}"></div>

    </div>
  </div>
</template>

<script>
import Navbar from '../components/Navbar'
import PanelPokreni from '../components/PanelPokreni'

export default {
    name: 'pravila',
    data: function () {
        return {
            html: ''
        }
    },
    async mounted () {
        try {
            var data = await this.$http.get(this.rulesUrl)
            this.html = data.data.data.post_content
        } catch (error) {
            console.error(error)
            this.html = '<p>Pravila možete pronaći na tonimilun.hr</p>'
        }
    },
    components: {
        Navbar,
        PanelPokreni
    },
    computed: {
        appState () {
            return this.$store.state.appState
        },
        poweredBy () {
            try {
                return this.$store.state.metadata.poweredBy
            } catch (error) { }
            return false
        },
        currentUrl () {
            var protocol = location.protocol
            var slashes = protocol.concat('//')
            var host = window.location.host
            return slashes.concat(host)
        },
        rulesUrl () {
            try {
                return `${this.currentUrl}/wp-json/wp/ea/document?id=${7351}`
            } catch (error) {
                console.error(error)
            }
            return ''
        }
    }
}
</script>

<style lang="scss" scoped>
.prev-button {
    position: absolute;
    z-index: 10;
    top: 35px;
    left: 16px;
    display: block;
    width: 25px;
    height: 25px;
    background: url(~@/assets/img/icons/arrow-back-black.png) 50% no-repeat;
    background-size: 24px;
}
.cnt {
    &.m-top {
        margin-top: 70px;
    }
    background: $blank-color;
    border-radius: 10px;
    padding: 10px;
    text-align: left;
    margin-bottom: 50px;
}
.pravila /deep/ {

    .title {
        text-align: center;
        padding: 38px 0 20px;
        font-size: 12px;
        font-family: $font-axiforma;
        font-weight: 800;
        color: #000;
        text-transform: uppercase;
        letter-spacing: 1px;
        background-color: #fff;
        margin-bottom: 30px;
    }
    .sub-title {
        font-family: $font-mPlus;
        font-weight: 800;
        font-size: 16px;
        color: #000;
        text-transform: uppercase;
        letter-spacing: -.1px;
        margin-bottom: 10px;
    }
    p {
        font-size: 16px;
        line-height: 1.8em;
        color: #555d63;
    }
    .cnt > div {
        font-size: 12px;
        line-height: 20px;
        color: #555d63;
        margin-bottom: 50px;
    }

    ol {
        list-style: decimal;
        padding-left: 20px;
        font-size: 12px;
        line-height: 20px;
        color: #555d63;
    }
    table {
        width: 100%;
        max-width: 600px;
        border-collapse: collapse;
        border: 1px solid #000;
        margin: 0;
        margin-bottom: 40px;
        box-shadow: 0 30px 30px -20px rgba(0,0,0,.5);
    }
    tr:nth-child(odd) {
        background-color: rgba(255,0,130,.5);
    }
    tr:nth-child(even) {
        background-color: rgba(100,168,233,.5);
    }
    th {
        border: 1px solid #000;
        font-family: $font-mPlus;
        font-weight: 800;
        font-size: 16px;
        color: #000;
        text-transform: uppercase;
        letter-spacing: -.1px;
        padding: 10px;
        text-shadow: 1px 1px 1px #000;
    }
    td {
        border: 1px solid #000;
        padding: 10px;
        font-size: 16px;
        text-align: center;
        color: #fff;
        text-shadow: 1px 1px 1px #000;
    }
    ul {
        list-style-type: disc;
        padding-left: 20px;
    }
    ul > li {
        font-size: 16px;
        color: #555d63;
        line-height: 20px;
    }
    h3 {
        font-size: 24px;
        font-weight: 700;
        line-height: 1.5em;
        color: #000;
    }
    p > strong {
        font-size: 20px;
    }
}

@media only screen and (min-width: 800px) {
    .pravila {
        max-width: 1280px;
        margin: auto;
    }
}
</style>
